import { useReducer, useEffect } from "react";
import Typography from "../../Typography";
import { Box, Grid } from "@mui/material";
import TooltipIndicators from "../../Dash/Tooltip";
import { renderActiveShape } from "../../Dash/NewDash/shapes";
import defaultReducer from "../../../utils/defaultReducer";
import api from "../../../api";
import { getSession } from "../../../auth";

import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  PieChart,
  Pie,
  ReferenceLine,
  Text,
} from "recharts";

import "./styles.css";
const loadChartComponent = ({ active, payload }) => {
  return null;
};
const red = "#e8534c";


const enterprise = getSession()?.profile.enterprise;

const CustomYAxisTick = (props) => {
  const { x, y, payload } = props;
  let desc = "";
  if (payload.value === 0) {
    desc = "Péssimo";
  } else if (payload.value < 5) {
    desc = "Ruim";
  } else if (payload.value === 5) {
    desc = "Neutro";
  } else if (payload.value < 7) {
    desc = "Bom";
  } else if (payload.value < 10) {
    desc = "Ótimo";
  } else if (payload.value === 10) {
    desc = "Perfeito";
  }
  return (
    <g transform={`translate(${x},${y})`}>
      <Text
        x={0}
        y={0}
        dy={16}
        textAnchor="end"
        fill="#666"
      >{`(${desc}) ${payload.value}`}</Text>
    </g>
  );
};

const CustomReferenceLabel = (props) => {
  const { x, y, viewBox, label } = props;
  const { value, textAnchor, ...rest } = label;

  // Calculate a dynamic y position if needed based on viewBox
  const labelY = y - 5;

  return (
    <Text x={x} y={labelY} textAnchor={textAnchor || "start"} {...rest}>
      {value} <tspan fill="blue">(Important)</tspan>
    </Text>
  );
};

const GroupsAndConversationsCount = (props) => {
  return (
    <Grid container spacing={2} id="dash-grid">
      <Grid item lg={12} md={12} sm={12} xs={12} className="grid-item">
        <Box id="small-frame" fullWidth>
          <Box className="dash-centralizer">
            <Box id="dash-box-1">
              <Box className="fontSize-title">
                <Typography
                  align="center"
                  text="Grupos"
                  color="darkGray"
                  fontWeight="500"
                  variant="subtitle1"
                />
              </Box>
              <Box className="dash-values" id="color-blue">
                {props.groups || 0}
              </Box>
            </Box>
          </Box>
          <TooltipIndicators text="Total de grupos com troca de mensagens no dia." />
        </Box>
      </Grid>

      <Grid item lg={12} md={12} sm={12} xs={12} className="grid-item">
        <Box id="small-frame" fullWidth>
          <Box className="dash-centralizer">
            <Box id="dash-box-1">
              <Box className="fontSize-title">
                <Typography
                  align="center"
                  text="Conversas"
                  color="darkGray"
                  fontWeight="500"
                  variant="subtitle1"
                />
              </Box>
              <Box className="dash-values" id="color-blue">
                {props.conversations || 0}
              </Box>
            </Box>
          </Box>
          <TooltipIndicators text="Total de conversas com troca de mensagens no dia." />
        </Box>
      </Grid>
    </Grid>
  );
};

const MessagesChart = (props) => {

  const [state, setState] = useReducer(defaultReducer, {
    activeIndex: 0,
  })
  return (
    <Grid container spacing={1} id="dash-grid" key={"scout-graph-1"}>
      <Grid item lg={12} md={12} sm={12} xs={12} className="grid-item">
        <Box className="big-frame-2" fullWidth>
          <Box className="tooltip-centralizer">
            <TooltipIndicators text="Total de mensagens trocadas pelos números Scout." />
          </Box>
          <Box className="fontSize-title">
            <Typography
              align="center"
              text="Mensagens"
              color="darkGray"
              fontWeight="500"
              variant="subtitle1"
            />
          </Box>
          <Box style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%'
          }}>
            <PieChart width={400} height={300} id="callsAndOperatorsGraph">
              <Pie
                activeIndex={state.activeIndex}
                activeShape={renderActiveShape}
                data={props.pieData}
                cx={200}
                cy={150}
                innerRadius={60}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
                onMouseEnter={(_, index) =>
                  setState({ activeIndex: index })
                }
              >

                {props.pieData !== undefined && props.pieData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={props.pieColors[index % props.pieColors.length]} />
                ))}
              </Pie>
              <Tooltip offset={-50} content={loadChartComponent} />
            </PieChart>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

const ProductsAndServicesChart = (props) => {
  return (
    <Grid container spacing={2} className="dash-grid" key={"scout-graph-2"}>
      <Grid item lg={12} md={12} sm={12} xs={12} className="grid-item">
        <Box className="big-frame-2"
        fullWidth>
          <Box className="tooltip-centralizer">
            <TooltipIndicators text="Contagem das citações dos produtos e serviços ofertados pela empresa." />
          </Box>
          <Box className="fontSize-title">
            <Typography
              align="center"
              text="Produtos e Serviços"
              color="darkGray"
              fontWeight="500"
              variant="subtitle1"
            />
          </Box>
          <Box style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%'
          }}>
            <BarChart
              width={400}
              height={300}
              data={props.products !== undefined ? props.products : []}
              margin={{
                top: 20,
                right: 30,
                left: 30,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis allowDecimals={false} />
              <Tooltip />

              <Legend />
              { props.productAccounts !== undefined &&  props.productAccounts.map((pa) => (

                <Bar key={pa.dataKey} dataKey={pa.dataKey} stackId="a" fill={pa.fill} />
              )) 
            }
            </BarChart>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

const SentimentChart = (props) => {
  const avg = props.sentiment && props.sentiment[0] ? props.sentiment[0]["Média"] : 5;
  return (
          <Grid container spacing={2} className="dash-grid" key={"scout-graph-1"}>
            <Grid item lg={12} md={12} sm={12} xs={12} className="grid-item">
              <Box className="big-frame-2" fullWidth>
                <Box className="tooltip-centralizer">
                  <TooltipIndicators text="Notas de satisfação da análise de sentimento das converas." />
                </Box>
                <Box className="fontSize-title">
                  <Typography
                    align="center"
                    text="Índice de Satisfação"	
                    color="darkGray"
                    fontWeight="500"
                    variant="subtitle1"
                  />
                </Box>
          <Box style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%'
          }}>
                  <BarChart
                    width={400}
                    height={300}
                    data={props.sentiment !== undefined ? props.sentiment : []}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 35,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis 
                      tick={<CustomYAxisTick />} 
                      domain={[0, 10]} 
                      allowDecimals={false}
                    />
                    <Tooltip />
                    <Legend />
                    <ReferenceLine
                      y={avg}
                      // stroke="#000"
                      stroke={red}
                      strokeDasharray="3 3"
                    />

                    <Bar dataKey="Média" fill={red}/>
                    {props.sentimentAccounts !== undefined && props.sentimentAccounts.map((sa) => (
                      <Bar key={sa.dataKey} dataKey={sa.dataKey} fill={sa.fill} />
                    ))}
                  </BarChart>
                </Box>
              </Box>
            </Grid>
          </Grid>
  );
};

const ScoutGeneralDashboard = ({ dashboardDate }) => {

  const [state, setState] = useReducer(defaultReducer, {
    loading: false,
    groups: 0,
    conversations: 0,
    products: [],
    productAccounts: [],
    pieData: [],
    pieColors: [],
    sentiment: [],
    sentimentAccounts: [],
  });
  useEffect(async () => {
    const d = await api.get(`api/enterprises/${enterprise.id}/scout_analytics/general/?date=${dashboardDate}`);
    if (d.status === 200) {
      setState({  
        groups: d.data.groups || 0,
        conversations: d.data.conversations|| 0,
        products: d.data.products || [],
        productAccounts: d.data.product_accounts || [],
        pieData: d.data.pie_data || [],
        pieColors: d.data.pie_colors || [],
        sentiment: d.data.sentiment || [],
        sentimentAccounts: d.data.sentiment_accounts || [],

      })
    } else if (d.status === 204) {
      console.log("No data available for the selected date.");
    } else {
      console.error("Error fetching dashboard data:", d.status, d.statusText);
    }

  }, [dashboardDate]);
  return (
    <Box id="dash-body">
      <Grid container spacing={1} id="dash-grid">
        <Grid item lg={4} md={4} sm={12} xs={12} className="grid-item">
          <GroupsAndConversationsCount conversations={state.conversations} groups={state.groups} />
        </Grid>

        <Grid item lg={8} md={8} sm={12} xs={12} className="grid-item">
          <ProductsAndServicesChart products={state.products} productAccounts={state.productAccounts} />
        </Grid>

        <Grid item lg={4} md={4} sm={12} xs={12} className="grid-item">
          <MessagesChart pieData={state.pieData} pieColors={state.pieColors} />
        </Grid>

        <Grid item lg={8} md={8} sm={12} xs={12} className="grid-item">
          <SentimentChart sentiment={state.sentiment} sentimentAccounts={state.sentimentAccounts} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ScoutGeneralDashboard;
